// src/services/authService.js
import { API_BASE_URL } from "../config";

const getLang = () => (localStorage.getItem("lang") === "en" ? "en" : "tr");

const defaults = {
  tr: {
    loginError: "Giriş yaparken bir hata oluştu.",
    loginErrorWithDetails: "Giriş yaparken bir hata oluştu: {{details}}",
  },
  en: {
    loginError: "An error occurred while signing in.",
    loginErrorWithDetails: "An error occurred while signing in: {{details}}",
  },
};

export const login = async (email, password) => {
  const response = await fetch(`${API_BASE_URL}/users/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    const lang = getLang();
    // Hata mesajı JSON ise onu parse etmeye çalış
    try {
      const errorData = JSON.parse(errorText);
      throw new Error(errorData.msg || defaults[lang].loginError);
    } catch (e) {
      throw new Error(defaults[lang].loginErrorWithDetails.replace("{{details}}", errorText));
    }
  }

  const data = await response.json(); // Backend'den dönen tüm datayı al

  // Token, isAdmin ve diğer kullanıcı bilgilerini döndür
  return {
    token: data.token,
    isAdmin: data.isAdmin,
    role: data.role,
    role_name: data.role_name,
    name: data.name,
    surname: data.surname,
    department: data.department,
    section: data.section,
    leave_balances: data.leave_balances,
  };
};
